import { render, staticRenderFns } from "./NewReports.vue?vue&type=template&id=d52dbb64&scoped=true&"
import script from "./NewReports.vue?vue&type=script&lang=js&"
export * from "./NewReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52dbb64",
  null
  
)

export default component.exports